class ValidarRequest {
  postValidarCreatePersona = (datosPersona) => {
    const {
      codigoTipoDocumento,
      numeroDocumento,
      nombre,
      apellidoPaterno,
      apellidoMaterno,
      fechaNacimiento,
      consentimientoInformativo,
      celular,
      correoEle,
      genero,
    } = datosPersona;
    return {
      datos: {
        codigoTipoDocumento,
        numeroDocumento,
        nombre,
        apellidoPaterno,
        apellidoMaterno,
        fechaNacimiento,
        consentimientoInformativo,
        celular,
        correo: correoEle,
        genero,
      },
    };
  };
}

export default ValidarRequest;
